"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var context_1 = __importDefault(require("atomicComponents/organisms/Dropdown/context"));
var DropdownWithExpandBtn_1 = __importDefault(require("atomicComponents/organisms/Dropdown/DropdownWithExpandBtn"));
var hooks_1 = require("containers/ConfirmationModal/hooks");
var CategoryTitle_1 = __importDefault(require("containers/Navbar/styles/CategoryTitle"));
var DropdownOption_1 = __importDefault(require("shared/components/DropdownMenu/DropdownOption"));
var populatedDerived_1 = require("utils/selectors/populatedDerived");
var single_1 = require("utils/selectors/single");
var utils_1 = require("./utils");
var DropdownOptions = function (_a) {
    var organizations = _a.organizations;
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var store = (0, react_redux_1.useStore)();
    var closeMenu = react_1.default.useContext(context_1.default).closeMenu;
    var prompt = (0, hooks_1.useConfirm)();
    var dateToday = (0, date_fns_1.format)(new Date(), 'yyyy-MM-dd');
    var downloadMappedCustomers = function (headers, fileName) {
        var state = store.getState();
        var customers = (0, populatedDerived_1.selectCustomersToRecharge)(state);
        if (!(customers === null || customers === void 0 ? void 0 : customers.length)) {
            prompt('No confirmed customers to export.', '', 'red', 'OK', true);
            closeMenu();
            return;
        }
        (0, utils_1.exportMappedCustomers)(customers, headers, fileName);
        closeMenu();
    };
    var downloadOrganizations = function () {
        if (!(organizations === null || organizations === void 0 ? void 0 : organizations.length)) {
            return;
        }
        (0, utils_1.exportOrganizations)(organizations, "Rechargly - ".concat(company === null || company === void 0 ? void 0 : company.name, "'s Organisations ").concat(dateToday, ".csv"));
        closeMenu();
    };
    var downloadOnlyMapped = function () {
        downloadMappedCustomers(utils_1.headersOnlyMapped, "Rechargly - ".concat(company === null || company === void 0 ? void 0 : company.name, "'s Customers ").concat(dateToday, ".csv"));
    };
    var downloadOnlyMappedWithAddress = function () {
        downloadMappedCustomers(utils_1.headersWithAddress, "Rechargly - ".concat(company === null || company === void 0 ? void 0 : company.name, "'s Customers with addresses ").concat(dateToday, ".csv"));
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "Organisations", autoFocus: true, onClick: downloadOrganizations }), (0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "Customers", onClick: downloadOnlyMapped }), (0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "Customers with address", onClick: downloadOnlyMappedWithAddress })] }));
};
var ExportCustomersDropdown = function (_a) {
    var organizations = _a.organizations;
    return ((0, jsx_runtime_1.jsxs)(DropdownWithExpandBtn_1.default, { children: [(0, jsx_runtime_1.jsx)(CategoryTitle_1.default, __assign({ px: 2 }, { children: "Export CSV" })), (0, jsx_runtime_1.jsx)(DropdownOptions, { organizations: organizations })] }));
};
exports.default = ExportCustomersDropdown;
